import React, { useState, useEffect } from "react";
import axios from "../../../../utils/axios";
import CustomDropdown from "../../../utilities/CustomDropdown";

const AssignCustomerDevice = (props) => {
  const [deviceList, setDeviceList] = useState([]);

  const getList = async () => {
    try {
      // Use dealer-specific endpoint to get only devices assigned to this dealer
      const viewDeviceList = await axios.post("view/devices/dealer");
      setDeviceList(viewDeviceList?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    (async () => {
      if (props.customerId && props.device) {
        try {
          await axios.post("assign/customer", {
            deviceId: props.device,
            customerId: props.customerId,
          });
        } catch (error) {
          console.log(error);
        }
      }
    })();
  }, [props.customerId, props.device]);

  // Filter only devices that are not assigned to any customer (customer_id is null)
  const filteredData = deviceList.filter((item) => item.customer_id === null);

  // Format filtered data for CustomDropdown
  const formattedDevices = filteredData.map((item) => ({
    id: item.id,
    name: item.alias_name,
  }));

  return (
    Array.isArray(filteredData) &&
    filteredData?.length !== 0 && (
      <div>
        <CustomDropdown
          label="Add Device"
          items={formattedDevices}
          value={props.value}
          onSelect={props.onChange}
          searchPlaceholder="Select Device..."
          showId={false}
          required={false}
        />
      </div>
    )
  );
};

export default AssignCustomerDevice;
